import { useState } from "react";

const projects = [
  {
    id: 1,
    type: "image",
    src: "https://static.wixstatic.com/media/28e51a_1ab868d799db45f2a4c2f24ff15778b7~mv2.jpg/v1/fill/w_1526,h_860,q_90,enc_avif,quality_auto/28e51a_1ab868d799db45f2a4c2f24ff15778b7~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_1ab868d799db45f2a4c2f24ff15778b7~mv2.jpg/v1/fill/w_763,h_430,q_90,enc_avif,quality_auto/28e51a_1ab868d799db45f2a4c2f24ff15778b7~mv2.jpg",
    label: "Full Replacement — NWA",
  },
  {
    id: 2,
    type: "image",
    src: "https://static.wixstatic.com/media/28e51a_91eb3c07fd6244f2b9f1e9f50d713d95~mv2.jpg/v1/fill/w_1832,h_1032,q_90,enc_avif,quality_auto/28e51a_91eb3c07fd6244f2b9f1e9f50d713d95~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_91eb3c07fd6244f2b9f1e9f50d713d95~mv2.jpg/v1/fill/w_916,h_516,q_90,enc_avif,quality_auto/28e51a_91eb3c07fd6244f2b9f1e9f50d713d95~mv2.jpg",
    label: "Storm Damage Restoration — DFW",
  },
  {
    id: 3,
    type: "image",
    src: "https://static.wixstatic.com/media/28e51a_d6de4d5a5265442cac2c09829ec62a56~mv2.jpg/v1/fill/w_1424,h_1372,q_90,enc_avif,quality_auto/28e51a_d6de4d5a5265442cac2c09829ec62a56~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_d6de4d5a5265442cac2c09829ec62a56~mv2.jpg/v1/fill/w_356,h_343,q_90,enc_avif,quality_auto/28e51a_d6de4d5a5265442cac2c09829ec62a56~mv2.jpg",
    label: "Insurance Claim Roof — Rogers, AR",
  },
  {
    id: 4,
    type: "image",
    src: "https://static.wixstatic.com/media/28e51a_c84b4c616684405cbd3a05d91a77084d~mv2.png/v1/fill/w_2142,h_1323,q_90,enc_avif,quality_auto/28e51a_c84b4c616684405cbd3a05d91a77084d~mv2.png",
    thumb: "https://static.wixstatic.com/media/28e51a_c84b4c616684405cbd3a05d91a77084d~mv2.png/v1/fill/w_555,h_343,q_90,enc_avif,quality_auto/28e51a_c84b4c616684405cbd3a05d91a77084d~mv2.png",
    label: "Residential Replacement — Bentonville, AR",
  },
  {
    id: 5,
    type: "video",
    src: "https://static.wixstatic.com/media/28e51a_e688a2ee336d49849d19941872406552~mv2.jpg/v1/fill/w_1014,h_570,q_90,enc_avif,quality_auto/28e51a_e688a2ee336d49849d19941872406552~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_e688a2ee336d49849d19941872406552~mv2.jpg/v1/fill/w_507,h_285,q_90,enc_avif,quality_auto/28e51a_e688a2ee336d49849d19941872406552~mv2.jpg",
    label: "#RidgecapWorks — Project Video",
  },
  {
    id: 6,
    type: "video",
    src: "https://static.wixstatic.com/media/28e51a_9de066c886fa45f9b040f3ecdcf1d706~mv2.jpg/v1/fill/w_1014,h_570,q_90,enc_avif,quality_auto/28e51a_9de066c886fa45f9b040f3ecdcf1d706~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_9de066c886fa45f9b040f3ecdcf1d706~mv2.jpg/v1/fill/w_507,h_285,q_90,enc_avif,quality_auto/28e51a_9de066c886fa45f9b040f3ecdcf1d706~mv2.jpg",
    label: "#RidgecapWorks — Aerial Footage",
  },
  {
    id: 7,
    type: "video",
    src: "https://static.wixstatic.com/media/28e51a_fb09017021e941b88dfe3d7c8c9b392b~mv2.jpg/v1/fill/w_1918,h_1080,q_90,enc_avif,quality_auto/28e51a_fb09017021e941b88dfe3d7c8c9b392b~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_fb09017021e941b88dfe3d7c8c9b392b~mv2.jpg/v1/fill/w_1019,h_574,q_90,enc_avif,quality_auto/28e51a_fb09017021e941b88dfe3d7c8c9b392b~mv2.jpg",
    label: "#RidgecapWorks — Installation Timelapse",
  },
  {
    id: 8,
    type: "video",
    src: "https://static.wixstatic.com/media/28e51a_012c06023e484303a65da6d74ba813a5~mv2.jpg/v1/fill/w_1526,h_858,q_90,enc_avif,quality_auto/28e51a_012c06023e484303a65da6d74ba813a5~mv2.jpg",
    thumb: "https://static.wixstatic.com/media/28e51a_012c06023e484303a65da6d74ba813a5~mv2.jpg/v1/fill/w_763,h_429,q_90,enc_avif,quality_auto/28e51a_012c06023e484303a65da6d74ba813a5~mv2.jpg",
    label: "#RidgecapWorks — Before & After",
  },
];

export default function ProjectsSection() {
  const [lightbox, setLightbox] = useState<number | null>(null);
  const [filter, setFilter] = useState<"all" | "image" | "video">("all");

  const filtered = filter === "all" ? projects : projects.filter((p) => p.type === filter);
  const current = lightbox !== null ? projects.find((p) => p.id === lightbox) : null;

  const handlePrev = () => {
    if (lightbox === null) return;
    const idx = projects.findIndex((p) => p.id === lightbox);
    const prev = (idx - 1 + projects.length) % projects.length;
    setLightbox(projects[prev].id);
  };

  const handleNext = () => {
    if (lightbox === null) return;
    const idx = projects.findIndex((p) => p.id === lightbox);
    const next = (idx + 1) % projects.length;
    setLightbox(projects[next].id);
  };

  return (
    <section id="projects" className="py-24 bg-[#f8f5f0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#f97316]/15 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
              <i className="ri-image-line"></i>
              Past Projects
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-[#1a1a2e] leading-tight mb-3">
              See the{" "}
              <span className="text-[#f97316]">#RidgecapWorks</span>{" "}
              in Action
            </h2>
            <p className="text-gray-500 text-base max-w-xl leading-relaxed">
              Take a look at some of our completed projects — from full insurance claim replacements to storm damage restorations across NWA and DFW.
            </p>
          </div>

          {/* Filter tabs */}
          <div className="flex items-center gap-2 bg-white rounded-full p-1 border border-gray-100">
            {(["all", "image", "video"] as const).map((tab) => (
              <button
                key={tab}
                onClick={() => setFilter(tab)}
                className={`px-5 py-2 rounded-full text-xs font-bold uppercase tracking-wide transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  filter === tab
                    ? "bg-[#1a1a2e] text-white"
                    : "text-gray-500 hover:text-[#1a1a2e]"
                }`}
              >
                {tab === "all" ? "All Work" : tab === "image" ? "Photos" : "Videos"}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {filtered.map((item, i) => (
            <div
              key={item.id}
              onClick={() => setLightbox(item.id)}
              className={`group relative overflow-hidden rounded-xl cursor-pointer ${
                i === 0 ? "sm:col-span-2 sm:row-span-2" : ""
              }`}
            >
              <div className={`w-full ${i === 0 ? "h-72 sm:h-full min-h-[340px]" : "h-52"} overflow-hidden`}>
                <img
                  src={item.thumb}
                  alt={item.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Video badge */}
              {item.type === "video" && (
                <div className="absolute top-3 left-3">
                  <span className="bg-[#f97316] text-white text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-play-fill text-xs"></i>
                    Video
                  </span>
                </div>
              )}

              {/* Play / zoom icon */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full border border-white/40">
                  <i className={`${item.type === "video" ? "ri-play-fill" : "ri-zoom-in-line"} text-white text-xl`}></i>
                </div>
              </div>

              {/* Label */}
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-white text-xs font-semibold">{item.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-12 bg-[#1a1a2e] rounded-2xl px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-[#f97316] text-xs font-bold uppercase tracking-widest mb-1">#RidgecapWorks</p>
            <h3 className="text-white font-black text-xl">Every one of these was an insurance claim.</h3>
            <p className="text-white/60 text-sm mt-1">Insurance-covered replacements — maximizing every dollar of your claim.</p>
          </div>
          <a
            href="#cta"
            className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-8 py-4 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 flex-shrink-0"
          >
            Start Your Free Claim Review
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && current && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); handlePrev(); }}
            className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={current.src}
              alt={current.label}
              className="w-full max-h-[80vh] object-contain rounded-xl"
            />
            <div className="mt-3 flex items-center justify-between">
              <p className="text-white/80 text-sm font-medium">{current.label}</p>
              {current.type === "video" && (
                <span className="bg-[#f97316] text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1">
                  <i className="ri-play-fill"></i>
                  Video Preview
                </span>
              )}
            </div>
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); handleNext(); }}
            className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>

          <button
            onClick={() => setLightbox(null)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      )}
    </section>
  );
}
